import { render } from "./InstallLocsPopover.vue?vue&type=template&id=31541590&scoped=true"
import script from "./InstallLocsPopover.vue?vue&type=script&lang=js"
export * from "./InstallLocsPopover.vue?vue&type=script&lang=js"

import "./InstallLocsPopover.vue?vue&type=style&index=0&id=31541590&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31541590"]])

export default __exports__